import { motion } from "motion/react";
import type { WizardPageViewModel } from '../wizardPageViewModel';
import { VisualisationGraphic } from './VisualisationGraphic';
import styles from './Visualisation.module.scss';

interface VisualisationProps {
  viewModel: WizardPageViewModel,
}

export function Visualisation({ viewModel }: VisualisationProps) {
  const stepName = viewModel.currentStep
    ? viewModel.currentStep.stepName
    : 'default';

  const getSelectedFlavours = () => {
    const currentStepName = viewModel.currentStep?.stepName;
    if (currentStepName === 'flavourSelect' || currentStepName === 'mouthfeelSelect' || currentStepName === 'tasteSelect') {
      return viewModel.currentStep!.flavours;
    }
    return [];
  };

  const getSelectedTastes = () => {
    const currentStepName = viewModel.currentStep?.stepName;
    if (currentStepName === 'mouthfeelSelect' || currentStepName === 'tasteSelect') {
      return viewModel.currentStep!.tastes;
    }
    return [];
  };

  const getSelectedMouthfeels = () => {
    const currentStepName = viewModel.currentStep?.stepName;
    if (currentStepName === 'mouthfeelSelect') {
      return viewModel.currentStep!.mouthfeels;
    }
    return [];
  };

  return (
    <motion.div className={ styles.wrapper } data-step={ stepName } initial={ { opacity: 0 } } animate={ { opacity: 1 } } transition={ { duration: 0.6, delay: 0.2 } }>
      <div className={ styles.wrapperInner }>

        <motion.div className={ styles.svgWrapper } initial={ { scale: 0.8 } } animate={ { scale: 1 } } transition={ { duration: 0.5, ease: 'easeOut' } }>
          <VisualisationGraphic
            viewModel={ viewModel }
            stepName={ stepName }
            selectedFlavourIds={ getSelectedFlavours() }
            selectedTasteIds={ getSelectedTastes() }
            selectedMouthfeelIds={ getSelectedMouthfeels() }
          />
        </motion.div>

      </div>
    </motion.div>
  );
}
